import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isDiscordEmbedded, setupDiscordProxyMappings } from '../discord/discordActivity';

/**
 * Discord Activities load through the proxy at `/`. Send embedded sessions to `/discord`.
 */
const DiscordRootRedirect: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (isDiscordEmbedded()) {
            setupDiscordProxyMappings();
        }
    }, []);

    useEffect(() => {
        if (location.pathname !== '/' || !isDiscordEmbedded()) return;
        navigate({ pathname: '/discord', search: location.search }, { replace: true });
    }, [location.pathname, location.search, navigate]);

    return null;
};

export default DiscordRootRedirect;
